import { gql, TypedDocumentNode } from '@common/hooks';

export const US_STATES_QUERY: TypedDocumentNode<UsStatesQueryResponse> = gql`
  query UsStates {
    usStates {
      text
      value
    }
  }
`;

type UsStatesQueryResponse = {
  usStates: {
    text: string;
    value: string;
  }[];
};
